import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SubscriptionSection from '../components/SubscriptionSection';
import OrgSettingsSection from '../components/OrgSettingsSection';
import AccountSection from '../components/AccountSection';
import TeamManagementSection from '../components/TeamManagementSection';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useSelector } from 'react-redux';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function SettingsPage() {
  const { settings } = useTranslatedMessages();
  useDocumentTitle(settings.page?.document_title || 'Settings');
  const user = useSelector((state) => state.user.user);
  const subscription = useSelector((state) => state.subscription.subscription);
  const isFromPartner = subscription?.is_from_partner;

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const defaultTab = 'account';
  const tabFromUrl = searchParams.get('tab');

  const [value, setValue] = React.useState(defaultTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 'team') {
      setSearchParams({ tab: newValue, subtab: searchParams.get('subtab') || 'roles' });
    } else {
      setSearchParams({ tab: newValue });
    }
  };

  React.useEffect(() => {
    if (user && !tabFromUrl) {
      setValue(defaultTab);
      setSearchParams({ tab: defaultTab });
    }
  }, [user, tabFromUrl, defaultTab, setSearchParams]);

  React.useEffect(() => {
    setValue(tabFromUrl);
    if (tabFromUrl === 'subscription' && !user?.is_root_user) {
      navigate('/settings?tab=account', { replace: true });
    }
    if (tabFromUrl === 'team' && !user?.is_root_user) {
      navigate('/settings?tab=account', { replace: true });
    }
  }, [tabFromUrl, user?.is_root_user, navigate]);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="settings tabs"
      >
        {user?.is_root_user && !isFromPartner && <Tab value="subscription" label={settings.tabs.subscription} />}
        {user?.is_root_user && <Tab value="orgSettings" label={settings.tabs.orgSettings} />}
        {user?.is_root_user && <Tab value="team" label={settings.tabs.teamManagement} />}
        <Tab value="account" label={settings.tabs.account} />
      </Tabs>

      <Box sx={{ p: 2 }}>
        {value === 'subscription' && <SubscriptionSection />}
        {value === 'orgSettings' && <OrgSettingsSection />}
        {value === 'team' && <TeamManagementSection />}
        {value === 'account' && <AccountSection />}
      </Box>
    </Box>
  );
}
